/**
 * Высота inline-превью на ленте FILEATTACHMENTS (Office DocEditor и PDF iframe).
 *
 * ⅔ ширины host (`offsetWidth`, до CSS zoom), не ниже минимума 480px.
 * Высоту формы не берём: измерение циклично.
 *
 * Модальный диалог Р7 заполняет свой host — эта формула только для inline.
 */

export const R7_EDITOR_HEIGHT_RATIO = 2 / 3

/** Ниже — у DS часто виден только toolbar (WUI-317). */
export const R7_EDITOR_MIN_HEIGHT_PX = 480

export function computeR7EditorIframeHeightPx(input: {
  editorWidthPx: number
  minHeightPx?: number
}): number {
  const minHeight = input.minHeightPx ?? R7_EDITOR_MIN_HEIGHT_PX
  const fromWidth = Math.floor(Math.max(0, input.editorWidthPx) * R7_EDITOR_HEIGHT_RATIO)
  return Math.max(minHeight, fromWidth)
}

export function isR7ModalEditorHost(host: HTMLElement): boolean {
  return Boolean(host.closest('.attachment-r7-editor-dialog'))
}

export function resolveR7EditorIframeHeightPx(host: HTMLElement): number {
  if (isR7ModalEditorHost(host)) {
    return Math.max(R7_EDITOR_MIN_HEIGHT_PX, host.offsetHeight || 0)
  }
  // offsetWidth — CSS-пиксели до zoom. getBoundingClientRect в Chrome уже со scale
  // (zoom < 1): visual width / scale → height → снова * scale на экране.
  return computeR7EditorIframeHeightPx({ editorWidthPx: host.offsetWidth })
}
